<template>
	<div class="full" id="summaryStatisticsChart"></div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import * as echarts from 'echarts';
	export default {
		props: {
			date: {
				default: () => {
					return ''
				}
			},
			kpi: {
				default: () => {
					return []
				}
			},
			formData: {
				default: () => {
					return null
				}
			},
			sourceData: {
				type: Array,
				default: () => {
					return []
				}
			},
			tableData: {
				type: Array,
				default: () => {
					return []
				}
			},
			chartField: {
				default: () => {
					return 'newUv'
				}
			},
			chartTitle: {
				default: () => {
					return '新访客数'
				}
			}



		},
		data() {
			return {
				chart: null,
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			//this.statisticsChart()
		},
		computed: {

		},

		methods: {
			createChart() {
				this.statisticsChart()
			},
			statisticsChart() {
				//console.log(this.chartTitle)
				let series = []
				let tableData = []
				let legend  = []
				tableData = JSON.parse(JSON.stringify(this.sourceData))
				console.log(tableData)
				let xarr = []
				tableData = this.$Lodash.orderBy(tableData, item => new Date(item.date), ['asc'])
				xarr = tableData.map((item) => {
					return item.date
				})
				let Yarr = this.$Lodash.groupBy(tableData, 'shopname')
				for(let i in Yarr){
					legend.push(i)
				}
				//console.log(tableData,Yarr)
				
				for (let i in Yarr) {
					series.push({
						name: i,
						type: 'line',
						label: {
							show: true,
							position: 'top'
						},
						emphasis: {
							focus: 'series'
						},
						data: Yarr[i].map((item) => {
							return item[this.chartField]
						})
					})
				}
				xarr = [...new Set(xarr)]
				//console.log(tableData,123)
				if (this.chart) {
					this.chart.clear()
				} else {
					this.chart = echarts.init(document.getElementById('summaryStatisticsChart'))
				}
				this.chart.setOption({
					title: {
						text: this.chartTitle,
						textStyle: {
							fontSize: 14
						}
					},
					legend: {
						data: legend
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					toolbox: {
						show: true,
						orient: 'vertical',
						left: 'right',
						top: 'center',
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: false
							},
							magicType: {
								show: true,
								type: ['line', 'bar', 'stack']
							},
							restore: {
								show: false
							},
							saveAsImage: {
								show: true
							}
						}
					},
					xAxis: {
						data: xarr
					},
					yAxis: {},
					series: series
				})


				//console.log(xarr,this.tableData)

			},
			groupBySum(array, groupKey, sumKey) {
				//console.log(array, groupKey, sumKey)
				return array.reduce((accumulator, item) => {
					let group = accumulator.find(i => i[groupKey] === item[groupKey]);
					if (group) {
						group[sumKey] += item[sumKey] ? parseFloat(item[sumKey]) : 0;
					} else {
						let newGroup = {};
						newGroup[groupKey] = item[groupKey];
						newGroup[sumKey] = parseFloat(item[sumKey]);
						accumulator.push(newGroup);
					}

					return accumulator;
				}, []);
			}
		},
		components: {

		}
	}
</script>